export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15087.2508b86c.jpg";